import api from '../../utils/api';
import {
    GET_LIST_BRANCH_FUNDS,
    GET_SPECIFIC_BRANCH_FUNDS,
    UPDATE_SPECIFIC_BRANCH_FUNDS,
    CREATE_NEW_BRANCH_FUNDS,
    REMOVE_BRANCH_FUNDS
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListBranchFunds = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/branch-funds', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_BRANCH_FUNDS, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        });
    });
};

export const getSpecificBranchFunds = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/branch-funds/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_BRANCH_FUNDS, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        });
    });
};

export const createBranchFunds = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/branch-funds', data).then(res => {
            dispatch({ type: CREATE_NEW_BRANCH_FUNDS, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        });
    });
};

export const updateBranchFunds = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/branch-funds/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_BRANCH_FUNDS, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        });
    });
};

export const removeBranchFunds = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/branch-funds`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_BRANCH_FUNDS, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        });
    });
};